<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { $router } from '@/router'
import { $bus } from '@/common/events'
import { dialog } from '@/common/dialog'
import { hcu } from '@/common/hcu'
import { createAdminMenu } from '@/menu/admin'
import { useTitle } from '@/composables/title'
import { useMenu, useSubmenu, useTopBar } from '@/composables/menu'
import { useSessionTimer } from '@/composables/session'
import { useScreensaver } from '@/composables/screensaver'
import { useMaintenance } from '@/composables/maintenance'
import Breadcrumbs from '@/components/Breadcrumbs.vue'
import Table from '@/components/Table.vue'

const actions = ref(createAdminMenu());

onMounted(() => {
  useTitle("Admin");
  useMenu("admin");
  useSubmenu(false);
  useTopBar(true);
  
  useSessionTimer(false);
});
</script>

<template>
  <div role="status" class="dark:bg-gray-900 dark:text-white p-5">

    <div class="grid place-items-start pb-8">
      <div class="flex flex-col gap-4 w-full">

        <!-- Title -->
        <div class="mb-2">
          <h2 class="text-lg font-bold dark:text-white">Admin</h2>
        </div>

        <!-- Feature buttons -->
        <div class="grid gap-2 w-full sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          <template v-for="action in actions">
            <a href="#" v-if="action.visible" @click="action.click()" class="flex justify-center px-12 py-6 bg-white border border-gray-200 rounded-lg shadow hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
              <h5 class="text-lg tracking-tight text-gray-900 dark:text-white truncate ellipsis">
                <i class="text-slate-400 mr-4 fa" :class="action.icon" v-if="action.icon"></i>
                <span>{{ action.title }}</span>
              </h5>
            </a>
          </template>
        </div>

      </div>
    </div>

  </div>
</template>

<style scoped>

</style>
